"use strict";

/* eslint-disable global-require */
var processInclude = require('base/util');
$(document).ready(function () {
//   processInclude(require('base/product/detail'));
  // Express payments on the PDP are not used. The host template
  // product/components/addToCartButtonExtension.isml is included by no template, so
  // #express-payment-buttons never exists and expressPayments.js threw a TypeError on
  // every product page load.
  // processInclude(require('./product/expressPayments'));
  processInclude(require('core/product/detail'));
  processInclude(require('core/product/wishlist'));
  processInclude(require('core/product/pralines'));
  require('core/product/imageSlider').init();
  require('core/product/stockNotification').init();
  require('core/product/personalisation').init();
});
